export function optionalSiteId(value: any): number | null {
  if (value == null || value === "" || value === 0 || (typeof value === "object" && Object.keys(value).length === 0)) return null;
  const id = typeof value === "object" ? value.id : value;
  if ((typeof id !== "number" && typeof id !== "string") || !/^\d+$/.test(String(id)) || Number(id) <= 0) throw new Error("invalid site");
  return Number(id);
}

export function orderValidation(order: any, supplier: boolean, business: any, site: any, itemCount: number): string[] {
  const errors: string[] = [];
  if (!String(order.name || "").trim()) errors.push("add order name");
  if (!order.created) errors.push("add created date");
  if (!supplier) {
    if (!order.business && !business?.id) errors.push("add a company");
    try { optionalSiteId(site); } catch { errors.push("invalid site"); }
  }
  if (!itemCount) errors.push("add one tool");
  return errors;
}

export function orderReferences(supplier: boolean, company: any, business: any, orderBusiness: any, site: any) {
  return {
    business: supplier ? company?.id : business?.id || orderBusiness?.id || orderBusiness || company?.id,
    project: supplier ? null : optionalSiteId(site),
  };
}

// Keep the same in-flight request for every caller until it settles.
export function singleFlight<T>() {
  let pending: Promise<T> | null = null;
  return (operation: () => Promise<T>): Promise<T> => {
    if (pending) return pending;
    pending = Promise.resolve().then(operation);
    const clear = () => { pending = null; };
    pending.then(clear, clear);
    return pending;
  };
}
